import { atom } from 'jotai'

type BannerDialogState = {
	title: string
	description: string
	actionLabel: string
}

export const bannerDialogStateAtom = atom<BannerDialogState | null>(null)
